module.exports = __webpack_public_path__ + "static/media/modal-edge-shape-2.bafdcb06.png";